import { useEffect } from 'react';
import { Box, Heading } from '@apia/theme';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import useModal from '../../../../../hooks/useModal';
import { documentsActions } from '../../../../../store/documentsSlice';
import { Modal } from '@apia/components';

const DocumentsModal = () => {
  const documents = useAppSelector((global) => global.documentsSlice.documents);
  const dispatch = useAppDispatch();

  const { show: showModal, onClose: hideModal, ...modalProps } = useModal();

  useEffect(() => {
    if (documents) showModal();
    else hideModal();
  }, [documents, hideModal, showModal]);

  if (!documents) return null;

  return (
    <Modal
      onClose={() => {
        dispatch(documentsActions.setDocuments(null));
      }}
      size="lg"
      title={documents.title}
      {...modalProps}
    >
      <Box {...window.getVariant('layout.common.modals.documents')}>
        {documents.sections.length === 0 && (
          <Heading as="h3">{documents.noDocumentsLabel}</Heading>
        )}

        {documents.sections.length > 0 &&
          documents.sections.map((section) => (
            <Box key={section.name}>
              <Heading as="h4">{section.name}</Heading>
              <ul>
                {section.documents.map((document) => (
                  <li key={document.name + document.url}>
                    <a
                      href={
                        document.url +
                        (document.docId
                          ? `&docId=${encodeURIComponent(document.docId)}`
                          : '')
                      }
                    >
                      {document.name}
                    </a>
                  </li>
                ))}
              </ul>
            </Box>
          ))}
      </Box>
    </Modal>
  );
};

export default DocumentsModal;
